import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Accordion, AccordionItem } from '@sm/wds-react';

import { UserDataMenu } from './UserDataMenu';
import { MyTeamMenu } from './MyTeamMenu';
import { ProductsMenu } from './ProductsMenu';
import { HelpMenu } from './HelpMenu';
import { Menu } from './components/Menu';

import authenticatedQuery from '../authenticated.graphql';

import ErrorBoundary from '../../../ErrorBoundary';

import { products, help, signOut } from '../../config/MobileLinkInfo';
import {
  authDashboard,
  authPlansAndPricing,
  authHome,
} from '../../config/linkInfo';

import './mobile-menu-auth.scss';

export const MobileAuth = () => {
  const { loading, error, data } = useQuery(authenticatedQuery, {});
  if (loading) return null;
  if (error) throw error;
  if (!data || !data.user) return null;
  const { user } = data;
  const teamMembership = user.teamMembership || {};
  const canSeeTeamTab = teamMembership.isAdmin || teamMembership.isEnterprise;

  return (
    <ErrorBoundary>
      <UserDataMenu />
      <Menu {...authDashboard()} />
      <Menu {...authHome()} />
      <If condition={canSeeTeamTab}>
        <MyTeamMenu user={user} />
      </If>
      <Menu {...authPlansAndPricing()} />
      <Accordion className="sm-mobile-menu-auth__li-accordionitem">
        <AccordionItem title={products().title}>
          <ProductsMenu />
        </AccordionItem>
        <AccordionItem title={help().title}>
          <HelpMenu />
        </AccordionItem>
      </Accordion>
      <Menu {...signOut()} />
    </ErrorBoundary>
  );
};

export default MobileAuth;
